
import { defineComponent, PropType, ref } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router/index";
import ThumbnailSelectSample, {
  ThumbnailSelectSampleItem,
} from "@/components/ThumbnailSelectSample.vue";
import { ITemplateSet } from "@/services/Models";
import { toResourceUrl } from "@/lib/shared";
import { IEditData } from "@/services/Models";

export default defineComponent({
  name: "TemplateThumbnailSelectSample",
  components: {
    ThumbnailSelectSample,
  },
  props: {
    item: { require: true, type: Object as PropType<ITemplateSet> },
    editData: { type: Object as PropType<IEditData> },
  },
  setup(props) {
    const router = useRouter();
    const isShowModal = ref(false);
    const showModal = () => {
      isShowModal.value = true;
    };
    const toEdit = () => {
      if (props.item === undefined) return;

      router.push({
        name: routeNames.EditTemplate,
        params: { templateID: 0 },
        query: { sampleID: props.item.id ?? 0 },
      });
      isShowModal.value = false;
    };
    const thumbnailItem = new ThumbnailSelectSampleItem({
      imgPath: toResourceUrl(props.item?.thumbnail ?? ""),
      clickAction: props.editData === undefined ? showModal : toEdit,
    });

    return {
      isShowModal,
      toEdit,
      thumbnailItem,
      toResourceUrl,
    };
  },
});
